import React from 'react'
import { useIntl } from 'react-intl'

import { BadgeShape, BadgeVariant } from '../../badge/constants'
import { IconBadge } from '../iconBadge/IconBadge'
import { SparkleGradient } from '../icons/SparkleGradient'

export const AIGeneratedTag: React.FC = () => {
  const { formatMessage } = useIntl()
  return (
    <IconBadge
      text={formatMessage({
        defaultMessage: 'AI generated',
        description: 'Badge label indicating content was generated by AI',
      })}
      variant={BadgeVariant.INFO_PRIMARY}
      shape={BadgeShape.RECT}
      frontIcon={<SparkleGradient size={18} />}
    />
  )
}
